export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  mapboxAccessToken: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN,
} as const;
